import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormTextField from '../../../FormFields/FormTextField';
import FormTitle from '../../../FormFields/FormTitle';
import { REPORTS } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { validateEmail } from '../../../ValidateFunctions';

TimeclockForm.propTypes = {
  permissions: PropTypes.object,
};

export default function TimeclockForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    REPORTS.TIMECLOCK_LABOR_DATA_SOURCE.id,
    REPORTS.TIMECLOCK_LABOR_DATA_INTEGRATION_TYPE.id,
    REPORTS.TIMECLOCK_LABOR_DATA_EMAIL.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Timeclock/Labor data
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {REPORTS.TIMECLOCK_LABOR_DATA_SOURCE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Data Source' }} />
              <FormTextField
                fieldName={REPORTS.TIMECLOCK_LABOR_DATA_SOURCE.fieldName}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                fieldAttributes={{
                  isEditable: permissions[REPORTS.TIMECLOCK_LABOR_DATA_SOURCE.id],
                }}
              />
            </Grid>
          )}
          {REPORTS.TIMECLOCK_LABOR_DATA_INTEGRATION_TYPE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Integration Type' }} />
              <FormTextField
                fieldName={REPORTS.TIMECLOCK_LABOR_DATA_INTEGRATION_TYPE.fieldName}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                fieldAttributes={{
                  isEditable: permissions[REPORTS.TIMECLOCK_LABOR_DATA_INTEGRATION_TYPE.id],
                }}
              />
            </Grid>
          )}
          {REPORTS.TIMECLOCK_LABOR_DATA_EMAIL.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
              <FormTextField
                fieldName={REPORTS.TIMECLOCK_LABOR_DATA_EMAIL.fieldName}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                fieldAttributes={{
                  isEditable: permissions[REPORTS.TIMECLOCK_LABOR_DATA_EMAIL.id],
                  validation: {
                    pattern: { ...validateEmail },
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
